import React from 'react'
import DatumLayout from 'datum/layout'
import SettingsPanels from './panels'

// Settings within the Datum app shell — lets a datum-only user reach the same
// organization/user settings (e.g. the is_user_admin Users tab).
const DatumSettings = () => (
  <DatumLayout title="Settings">
    <SettingsPanels />
  </DatumLayout>
)

export default DatumSettings
